import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { SettingService } from 'src/app/services/setting/setting.service';
declare var Swal: any;

@Component({
  selector: 'app-proforma-settings',
  templateUrl: './proforma-settings.component.html',
  styleUrls: ['./proforma-settings.component.scss'],
  encapsulation: ViewEncapsulation.None
})



export class ProformaSettingsComponent extends DestructorComponent {

  data: any;
  proformaSettingsForm: FormGroup;
  isLoading: boolean = false;
  settingId: string = '';

  constructor(
    private _settingService: SettingService,
    private _globalService: GlobalStateService,
    private fb: FormBuilder
  ) {
    super();
    this.initializeForm();
  }

  ngOnInit(): void {
    this.GetData();
  }

  initializeForm(): void {
    this.proformaSettingsForm = this.fb.group({
      admin_comments: ['', [Validators.required]],
      sales_agreement: ['', [Validators.required]],
      shipment_remark: ['', [Validators.required]]
    });
  }

  GetData(): void {
    this.subscriptions.push(
      this._globalService.GetSetting().subscribe((res: any) => {
        this.data = res.proforma_settings;
        this.settingId = res._id;
        console.log(this.data);

        // Populate form with existing data
        if (this.data) {
          this.proformaSettingsForm.patchValue({
            admin_comments: this.data.admin_comments || '',
            sales_agreement: this.data.sales_agreement || '',
            shipment_remark: this.data.shipment_remark || ''
          });
        }
      })
    );
  }

  onSubmit(): void {
    if (this.proformaSettingsForm.valid) {
      this.isLoading = true;

      const formData = this.proformaSettingsForm.getRawValue();

      // Prepare data for API
      const submitData = {
        "proforma_settings": {
          admin_comments: formData.admin_comments,
          sales_agreement: formData.sales_agreement,
          shipment_remark: formData.shipment_remark
        }
      };

      console.log('Submitting proforma settings:', submitData);

      // Call the SettingService to update proforma settings
      this.subscriptions.push(
        this._settingService.UpdateData(this.settingId, submitData).subscribe({
          next: (response: any) => {
            this.isLoading = false;
            console.log('Proforma settings updated successfully:', response);

            // Show success message
            Swal.fire({
              text: "Proforma settings have been successfully updated!",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn btn-primary"
              }
            }).then((result: any) => {
            });
          },
          error: (error: any) => {
            this.isLoading = false;
            console.error('Error updating proforma settings:', error);

            // Show error message
            Swal.fire({
              text: "Sorry, looks like there are some errors detected, please try again.",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn btn-primary"
              }
            });
          }
        })
      );
    } else {
      // Mark all form fields as touched to show validation errors
      this.markFormGroupTouched(this.proformaSettingsForm);

      // Show validation error message
      Swal.fire({
        text: "Please fill in all required fields correctly.",
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: "Ok, got it!",
        customClass: {
          confirmButton: "btn btn-primary"
        }
      });
    }
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      control?.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

}
